import React from "react";
import { BaseEdge, getBezierPath, type EdgeProps } from "@xyflow/react";
import { cn } from "@/lib/utils";

const edgeColorMap: Record<string, string> = {
  strategic: "stroke-category-strategy",
  financial: "stroke-category-finance",
  operational: "stroke-category-operations",
  risk: "stroke-category-risk",
  info: "stroke-category-documents",
};

export function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}: EdgeProps) {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const relationType = (data?.type as string) || "info";
  const strokeClass = edgeColorMap[relationType] || "stroke-border-strong";

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      markerEnd={markerEnd}
      style={style}
      className={cn(
        "stroke-[2px] transition-all hover:stroke-[3px] fill-none",
        strokeClass,
      )}
    />
  );
}
